import React from "react";
import {t} from "i18next";
import MarkdownEditor from "../../../components/MarkdownEditor";
import {FieldNames} from "../../../models/fields";
import {getFormattedDate, isISODate} from "../../../utils/dateutils";

function getUsernameFromUserId(users, userIds) {
  const usernames = users.reduce((acc, user) => {
    if (userIds?.includes(user[FieldNames.userId])) {
      acc.push(user[FieldNames.userName]);
    }
    return acc;
  }, []);

  return usernames?.length > 0 ? (
    <ul>
      {usernames.map((user, index) => (
        <li key={`${user}-${index}`}>{user}</li>
      ))}
    </ul>
  ) : (
    t("incidentDetail.worklogTab.auditLogPanel.allAssigneesRemoved")
  );
}

/**
 * @param {object} object
 * @return {object}
 */
function formatDatesInObject(object) {
  return Object.entries(object).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: isISODate(value) ? getFormattedDate(value) : value
    }),
    {}
  );
}

/**
 * @param {unknown} content
 * @return {string}
 */
function formatChangeObject(content) {
  switch (typeof content) {
    case "string":
      return content;
    case "number":
      return `${content}`;
    case "object":
      return JSON.stringify(formatDatesInObject(content));
    default:
      return JSON.stringify(content);
  }
}

export default function AuditLogItem({item, users}) {
  const {field, change} = item;
  switch (field) {
    case FieldNames.assignees:
      return <div>{getUsernameFromUserId(users, change.after)}</div>;
    case FieldNames.description:
      return (
        <div>
          <MarkdownEditor
            active={false}
            minPreviewHeight={10}
            value={formatChangeObject(change.after)}
          />
        </div>
      );
    default:
      return <div>{formatChangeObject(change.after)}</div>;
  }
}
